import { useTranslation } from "react-i18next";
import {
  Box,
  Container,
  Heading,
  Text,
  Stack,
  Button,
  Icon,
  Link,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import { FaEnvelopeOpenText } from "react-icons/fa";

const MotionBox = motion(Box);
const MotionHeading = motion(Heading);
const MotionText = motion(Text);

export default function Careers() {
  const mainColor = "#000";
  const accentColor = "#c6a664"; 
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const careersData = t("careers", { returnObjects: true });
  const contact = t("contact", { returnObjects: true });

  return (
    <Box
      id="careers"
      py={{ base: 12, md: 20 }}
      dir={isArabic ? "rtl" : "ltr"}
      overflow="hidden"
      position="relative"
      bg="white"
    >
      <Container maxW="6xl" position="relative" zIndex={1}>
        {/* Section Title */}
        <MotionHeading
          textAlign="center"
          fontSize={{ base: "2xl", md: "4xl" }}
          color={mainColor}
          mb={6}
          initial={{ opacity: 0, y: -40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          {careersData.title}
        </MotionHeading>

        {/* Description */}
        <MotionText
          textAlign="center"
          fontSize={{ base: "md", md: "lg" }}
          color="gray.700"
          maxW="3xl"
          mx="auto"
          mb={10}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.7, delay: 0.2 }}
          viewport={{ once: true }}
        >
          {careersData.description}
        </MotionText>

        {/* Call to Action */}
        <Stack align="center" justify="center" spacing={4}>
          <MotionBox
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <Button
              leftIcon={<Icon as={FaEnvelopeOpenText} />}
              size="lg"
              colorScheme="blackAlpha"
              variant="outline"
              borderColor={mainColor}
              color={mainColor}
              _hover={{
                bg: mainColor,
                color: "white",
                borderColor: mainColor,
              }}
            >
              <Link
                href={`mailto:${contact.email || "info@alphaunited.com.sa"}`}
                _hover={{ textDecoration: "none", color: "white" }}
              >
                {isArabic ? "تواصل عبر البريد الإلكتروني" : "Contact via Email"}
              </Link>
            </Button>
          </MotionBox>

          <Text
            fontSize="sm"
            color="gray.500"
            textAlign="center"
            mt={2}
          >
            {isArabic
              ? "نرحب بانضمام الكفاءات الجديدة إلى فريقنا"
              : "We welcome new talents to join our team"}
          </Text>
        </Stack>
      </Container>
    </Box>
  );
}
